// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__f9jWS","Vertical":"Container_Vertical__lSDsP"};